var map = {
	"./1-pork-chop/index.html": 375,
	"./2-ribeye/index.html": 376,
	"./_template.js": 365,
	"./index.js": 377
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 374;



/*****************
 ** WEBPACK FOOTER
 ** . (coffee|cjsx|jsx|js|markdown|md|html|json|yaml|toml)$
 ** module id = 374
 ** module chunks = 0
 **/